import { FetchStatus } from 'types/api';
import { RegisterData } from 'types/register';
import { isAxiosError } from 'axios';
import { useState } from 'react';
import { registerModuleApi } from 'modules/RegisterModule/api';

export const useRegister = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);

  const register = async (data: RegisterData, password: string) => {
    try {
      setStatus('loading');
      const payload = {
        password,
        invite_uuid: data.inviteId,
        assistant_name: data.employeeName,
        full_name: data.name,
        gender: data.gender,
        communication_style: data.communicationTrait,
      };
      await registerModuleApi.registerUser(payload);
      setStatus('success');
    } catch (error) {
      setStatus('failed');
      if (isAxiosError(error)) {
        const inviteError = error.response?.data?.invite_uuid?.[0];
        if (inviteError) {
          return setError('Invalid invite id');
        }
        const axiosError = error.response?.data?.toString();
        if (axiosError) {
          return setError(axiosError);
        }
      }
      setError('Something went wrong');
    }
  };
  return { status, error, register };
};
